import React, { useState } from "react";
import { useTransition, animated } from "react-spring";
import { TfiClose } from "react-icons/tfi";
import { HiCheck } from "react-icons/hi";
import {
  Facebooklink,
  Messanger,
  Instagramlink,
  Link,
  Linkedinlink,
  Pinterestlink,
  Twitterlink,
  Whatsapplink,
  Linkoption,
  linkoption_MA,
  linkoption_Zyia,
  linkoption_Yoli,
  linkoption_default,
} from "../../../../assets/icons";
import useAppAccessor from "../../../../hooks/useappAccessor";

const CustomBottomSheet = ({
  isOpen,
  toggleSheet,
  selectedType,
  selectedName,
  selectedIconName,
}: any) => {
  const [selectedOption, setSelectedOption] = useState("");
  const { getUserData } = useAppAccessor();
  const { language, client } = getUserData();
  const transitions = useTransition(isOpen, {
    from: { opacity: 0, transform: "translateY(10%)" },
    enter: { opacity: 1, transform: "translateY(0%)" },
    leave: { opacity: 0, transform: "translateY(10%)" },
  });

  const SocialIconRow = ({
    name = "",
    iconName = "",
    type = "",
  }: {
    name?: string;
    iconName: any;
    type: string;
  }) => {
    return (
      <>
        <div
          className="flex w-full justify-between items-center py-2 cursor-pointer"
          onClick={() => {
            setSelectedOption(type);
            selectedType(type);
            selectedName(name);
            selectedIconName(iconName);
            toggleSheet();
          }}
        >
          <div className="flex">
            <img
              src={iconName}
              alt="Icon"
              height={22}
              width={22}
              className="mr-3"
            />
            <span className="text-[#FFFFFF] text-base mr-2">{name}</span>
          </div>
          {type == selectedOption && (
            <HiCheck
              color="#B59EFF"
              size={24}
              cursor="pointer"
              fontWeight={"bold"}
            />
          )}
        </div>
      </>
    );
  };

  const checkBrandOptions = (client: any) => {
    switch (client) {
      case "marketamerica": {
        return linkoption_MA;
      }
      case "zyiaactive": {
        return linkoption_Zyia;
      }
      case "beyondslim": {
        return linkoption_Zyia;
      }
      case "Yoli": {
        return linkoption_Yoli;
      }
      case "Verb": {
        return linkoption_default;
      }
      case "Hussle": {
        return linkoption_default;
      }

      default:
        return linkoption_MA;
    }
  };

  return transitions((styles: any, item: any) =>
    item ? (
      <animated.div style={{ ...styles }}>
        <div
          className="h-full w-full flex flex-col px-3 pointer-events-auto rounded-t-xl"
          style={{ backgroundColor: "#313233" }}
        >
          <div className="flex w-full justify-between  h-10 items-center">
            <div className="h-2.5 w-2.5"></div>
            <TfiClose
              color="#DEDEDE"
              size={20}
              cursor="pointer"
              onClick={toggleSheet}
            />
          </div>
          <div>
            <span className="text-[#DEDEDE] text-[22px] ">
              {language["social_media"]}
            </span>
          </div>
          <div className="border-t-[1px] border-b-[1px] border-[#414141]  bg-[#222324] mt-2"></div>
          <SocialIconRow
            name="Facebook"
            iconName={Facebooklink}
            type={"A"}
          ></SocialIconRow>
          <SocialIconRow
            name="Instagram"
            iconName={Instagramlink}
            type={"B"}
          ></SocialIconRow>
          <SocialIconRow
            name="LinkedIn"
            iconName={Linkedinlink}
            type={"C"}
          ></SocialIconRow>
          <SocialIconRow
            name="Twitter"
            iconName={Twitterlink}
            type={"D"}
          ></SocialIconRow>
          <SocialIconRow
            name="Pinterest"
            iconName={Pinterestlink}
            type={"E"}
          ></SocialIconRow>

          <div className="mt-3">
            <span className="text-[#DEDEDE] text-[22px] ">
              {language["messengers"]}
            </span>
          </div>
          <div className="border-t-[1px] border-b-[1px] border-[#414141]  bg-[#222324] mt-2"></div>
          <SocialIconRow
            name="Messenger"
            iconName={Messanger}
            type={"F"}
          ></SocialIconRow>
          <SocialIconRow
            name="WhatsApp"
            iconName={Whatsapplink}
            type={"G"}
          ></SocialIconRow>
          <SocialIconRow
            name="Instagram"
            iconName={Instagramlink}
            type={"H"}
          ></SocialIconRow>
          <SocialIconRow
            name="Twitter"
            iconName={Twitterlink}
            type={"I"}
          ></SocialIconRow>

          <div className="mt-3">
            <span className="text-[#DEDEDE] text-[22px] ">
              {language["custom"]}
            </span>
          </div>
          <div className="border-t-[1px] border-b-[1px] border-[#414141]  bg-[#222324] mt-2"></div>
          <SocialIconRow
            name="Add link"
            iconName={checkBrandOptions(client)}
            type={"J"}
          ></SocialIconRow>
          <div className="border-t-[1px] border-b-[1px] border-[#414141]  bg-[#222324] mt-2 mb-3.5"></div>
        </div>
      </animated.div>
    ) : null
  );
};

export default CustomBottomSheet;
